import { render } from "./InstaFeed.vue?vue&type=template&id=4d28fc52"
import script from "./InstaFeed.vue?vue&type=script&lang=js"
export * from "./InstaFeed.vue?vue&type=script&lang=js"

import "./InstaFeed.vue?vue&type=style&index=0&id=4d28fc52&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__